
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import { mapGetters } from 'vuex';

export default {
name: 'ProductDetail',
data() {
return {
check: true,
show: false,
showPopup: false,
prodItem: {},
flavour: '',
spec: '',
specList: [],
flavourList: [],
distributionStatus: false,
distributionPrice: 0.0,
distributionUnit: '',
price: 0.0,
unit: '',
price2: 0.0,
unit2: '',
icon_index: 0,
picture_list: [],
picture_unit_list: [],
productPicture: [],
productAdvert: [],
prodPicture: '',
adPathShow: false,
ProdMsg: {},
categoryId: '',
isShowLink: true,
}
},
components: {
Flexbox,
FlexboxItem,
Checker,
CheckerItem,
Popup,
Group,
Cell,
CellBox,
Swiper,
SwiperItem
},
directives: {
TransferDom
},
computed: {
...mapGetters([ 'thirdParty' ]),
},
mounted() {
if (this.$route.params.product) {
this.ProdMsg = this.$route.params
this.loadData()
const have = this.$route.params.product.some(item => ['20', '23'].includes(item.categoryId))
this.isShowLink = !(have && this.thirdParty === '1')
} else {
const {thirdParty, categoryId, prodId } = this.$route.query
this.$store.replaceState({
thirdParty,
});
this.queryProductDetailById(categoryId, prodId)
this.isShowLink = !(['20', '23'].includes(categoryId) && this.thirdParty === '1')
}
},
methods: {
loadData() {
this.prodItem = {
categoryId: this.ProdMsg.product[0].categoryId,
prodName: this.ProdMsg.product[0].prodName,
prodId: this.ProdMsg.product[0].prodId,
discription: this.ProdMsg.product[0].productFlavour[0].productDetail[0].discription.split('!@')
}

this.productPicture = this.ProdMsg.productPicture

this.flavourList = this.ProdMsg.product[0].productFlavour
this.flavour = this.flavourList[0].flavour

this.specList = this.flavourList[0].productDetail.sort((a, b) => {
if (a.salePrice > b.salePrice) {
return 1
} else {
return -1
}
})
this.spec = this.specList[0].spec

let spec_img_list = this.specList[0].productPicture
let spec_unit_img_list = this.specList[0].productUnitPicture
this.picture_list = []
this.picture_unit_list = []
let _this = this
spec_img_list.forEach(item => {
let picture = { img: item.picturePath }
_this.picture_list.push(picture)
})
spec_unit_img_list.forEach(item => {
let picture = { img: item.picturePath }
_this.picture_unit_list.push(picture)
})

this.price = this.specList[0].salePrice
this.unit = this.specList[0].unit
this.price2 = this.specList[0].salePrice2
this.unit2 = this.specList[0].unit2

if (this.specList[0].distributionPrice) {
this.distributionStatus = true
this.distributionPrice = this.specList[0].distributionPrice
this.distributionUnit = this.specList[0].distributionUnit
}
if (this.ProdMsg.productAdvert.length > 0) {
this.productAdvert = this.ProdMsg.productAdvert
this.adPathShow = this.ProdMsg.productAdvert[0].adPath ? true : false
} else {

}
},
onTasteClick(value, disabled) {
this.specList = value.productDetail.sort((a, b) => {
if (a.salePrice > b.salePrice) {
return 1
} else {
return -1
}
})
this.getspec(this.specList[0])
this.spec = this.specList[0].spec
},
onStandardClick(value, disabled) {
this.getspec(value)
},
getspec(value) {
this.picture_list = []
this.picture_unit_list = []
this.icon_index = 0
this.prodItem.discription = value.discription.split('!@')
this.distributionPrice = value.distributionPrice
this.distributionUnit = value.distributionUnit
this.price = value.salePrice
this.unit = value.unit
this.price2 = value.salePrice2
this.unit2 = value.unit2
if (value.productPicture && value.productPicture.length > 0) {
let _this = this
value.productPicture.forEach(item => {
let picture = { img: item.picturePath } 
_this.picture_list.push(picture)
})
}
if (value.productUnitPicture && value.productUnitPicture.length > 0) {
let _this = this
value.productUnitPicture.forEach(item => {
let picture = { img: item.picturePath } 
_this.picture_unit_list.push(picture)
})
}
},
onIndexChange() {
this.$router.push({ name: 'ProductCenter', params: this.prodItem })
},
gotoBuy(type) {
if (type === 'JD') {
window.open('https://wangwangshipin.jd.com/')
} else if (type === 'TM') {
window.open('https://wangwangshipin.tmall.com/?spm=687.8433302/new.33000091006.1.296f226aTJllT8')
} else {
window.open('https://srv.hotkidceo.com/store/?utm_source=untrack#/')
}
},
backTop() {
document.body.scrollTop = 0
document.documentElement.scrollTop = 0
},
queryProductDetailById(categoryId, prodId) {
let url = `${this.API_ROOT}queryProductDetailById`
let userId = sessionStorage.getItem('userId')
this.$http({
method: 'get',
url: url,
params: {
categoryId: categoryId,
prodId: prodId,
userId: userId
}
}).then(
res => {
if (res.data.mapDatas) {
this.ProdMsg = res.data.mapDatas
this.loadData()
} else {
alert('返回数据为空,请联系管理员检查')
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},
},
beforeRouteLeave(to, from, next) {
if (to.name == 'ProductCenter') {
from.meta.keepAlive = false
to.meta.keepAlive = true
next()
}
},

}



// WEBPACK FOOTER //
// ./src/components/ProductDetail.vue